export const convertShortName = {
  da: 'danish',
  de: 'deutsch',
  en: 'english',
  fi: 'finnish',
  fr: 'french',
  nb: 'norwegian',
  nl: 'dutch',
  ru: 'russian',
  sv: 'swedish',
};
